import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { AppConfigContext } from '@infl-ts/util-app-config';
import { Challenge } from '@infl-ts/util-fetch-challenge-list';
import { useToggle } from '@infl-ts/util-hooks';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import { Box } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { pipe } from 'fp-ts/function';
import * as t from 'io-ts';
import { useContext } from 'react';
import { Profile } from '../codecs';
import OnboardingError from '../onboarding-error';
import { onboardingChallengeFragment } from './index';
import { OnboardingChallenge } from './onboarding-challenge';
import { jsx as _jsx } from "react/jsx-runtime";
var useOnboardingConfigPreview = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query OnboardingConfigPreview($id: ID!) {\n      challenge: node(id: $id) {\n        ... on Challenge {\n          ...OnboardingChallengeFragment\n        }\n      }\n      profile {\n        id\n        username\n        name\n        email\n        title\n        company\n        avatarUrl\n        isAdmin\n      }\n    }\n\n    ", "\n  "])), onboardingChallengeFragment), t.type({
  challenge: nullable(Challenge),
  profile: t.intersection([Profile, t.type({
    isAdmin: t["boolean"]
  })])
}), t.type({
  id: t.string
}));
export var ChallengeOnboardingPreview = function ChallengeOnboardingPreview(_ref) {
  var challengeId = _ref.challengeId,
      skippable = _ref.skippable;

  var _useToggle = useToggle(true),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      showOnboardingChallenge = _useToggle2[0],
      hideOnboardingChallenge = _useToggle2[1].off;

  var _useContext = useContext(AppConfigContext),
      activeLens = _useContext.modes.activeLens;

  return pipe(useOnboardingConfigPreview({
    variables: {
      id: challengeId
    }
  }), DE.squash(function () {
    return /*#__PURE__*/_jsx(Box, {});
  }, function () {
    return /*#__PURE__*/_jsx(OnboardingError, {});
  }, function (_ref2) {
    var challenge = _ref2.challenge,
        profile = _ref2.profile;
    return challenge && showOnboardingChallenge && (profile.isAdmin || activeLens) ? /*#__PURE__*/_jsx(OnboardingChallenge, {
      challenge: challenge,
      profile: profile,
      canClose: skippable,
      onClose: hideOnboardingChallenge,
      isPreview: true
    }) : null;
  }));
};